import * as pubsub from "pubsub-js";

enum DocumentEvent {
	// When user changes preference
	// data object is undefined
	PreferenceChanged = "documents.editorPreference.Changed",
}

type Data<T extends DocumentEvent> =
	T extends DocumentEvent.PreferenceChanged ? undefined :
	never;

export const subscribe: <T extends DocumentEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends DocumentEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;

export {
	DocumentEvent
};
